<template>
  <div class="fb-container">
    <div class="inp_box">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="content"
        maxlength="200"
        show-word-limit
        size="medium "
        resize="none"
        :rows="5"
      >
      </el-input>
    </div>
    <div class="feedback-btn"><button @click="submitfeed">提交反馈</button></div>
  </div>
</template>

<script>
import {ApiSendFeedback} from '../../../net/accound/index.js'
export default {
  data: function () {
    return {
      content: ''
    }
  },
  methods:{
    submitfeed: function () {
      ApiSendFeedback({content: this.content}).then(res=>{
        this.content = ''
        this.$message.success('反馈成功，请耐心等待工作人员处理')
      })
    }
  }
}
</script>

<style scoped>
.fb-container{
  width: 850px;
  background:#fff;
  height: 500px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.inp_box{
  width: 80%;
  height: 100px;
  margin: 100px auto;
}
.feedback-btn{
  width: 100%;;
  text-align: center;
  margin: 0 auto;
}
.feedback-btn button{
  width: 180px;
  height: 48px;
  background-color: #0AAC50;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  border:none;
  cursor:pointer;
  }
.feedback-btn button:hover{
  background-color: #019B3C;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AccMyTool/children/feedback.vue